<template>
    <l-marker v-if="issData != undefined"
        :lat-lng="latlng"
        :options="{riseOnHover: true, riseOffset: 3000}"
    >
        <l-icon 
            :icon-url="require('../assets/map/space.svg')" 
            :icon-size="[40, 40]" />
        <l-popup>
            <strong>International Space Station</strong><br />
            Höhe: <strong>{{Math.round(issData.altitude * 1000) / 1000}} km</strong><br />
            Geschwindigkeit: <strong>{{Math.round(issData.velocity * 100) / 100}} km/h</strong>
        </l-popup>
    </l-marker>
</template>

<script>
// EasterEgg: Diese Komponente zeigt die Internationale Raumstation live mit Daten auf der Karte an
import { LMarker, LIcon, LPopup } from 'vue2-leaflet'
export default {
    name: "UebersichtMarkerSpace",
    components: {
        LMarker,
        LIcon,
        LPopup
    },
    computed:{
        latlng: function () {
            return this.issData == undefined ? [49, 12] : [this.issData.latitude, this.issData.longitude]
        }
    },
    data() {
        return {
            issData: undefined,
            updateInterval: undefined
        }
    },
    methods:{
        getIssLocation() {
            try {
                var that = this
                var request = new XMLHttpRequest()
                request.open("GET", "https://api.wheretheiss.at/v1/satellites/25544?suppress_response_codes=true", true)
                request.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                        that.issData = JSON.parse(this.responseText)
                    }
                };
                request.send()
            }
            catch{
                this.issData = undefined
            }
        }
    },
    async created() {
        this.getIssLocation()
        this.updateInterval = setInterval(this.getIssLocation, 10000)
    },
    destroyed(){
        clearInterval(this.updateInterval)
    }
}
</script>